import { useStripe } from '@stripe/react-stripe-js'
import { StripeCardElement } from '@stripe/stripe-js'
import { StaffAvailability } from 'components/DropdownSelectors/common'
import React, { useContext, useState } from 'react'
import { Client } from 'types/client'
import { postApiRequest } from 'utils/fetch-helper'
import {
    AppointmentDrawerContext,
    AppointmentDrawerProvider,
} from './AppointmentDrawerContext'
import {
    IAppointmentFormData,
    initialFormValues,
    initialValues,
} from './AppointmentDrawerType'

const AppointmentDrawerContainer = ({ children }: any) => {
    const [formData, setFormData] =
        useState<IAppointmentFormData>(initialFormValues)
    const [attendeeData, setAttendeeData] = useState<any>(
        initialValues.attendeeData
    )
    const [selectedClient, setSelectedClient] = useState(
        initialValues.selectedClient
    )
    const [displayAddAttendeeModal, setDisplayAddAttendeeModal] = useState(
        initialValues.displayAddAttendeeModal
    )
    const [shouldApplyCouponCode, setShouldApplyCouponCode] = useState(
        initialValues.shouldApplyCouponCode
    )
    const [couponInfo, setCouponInfo] = useState<any>({})
    const [applyFreeAppointment, setApplyFreeAppointment] = useState(
        initialValues.applyFreeAppointment
    )
    const [displayNewClientForm, setDisplayNewClientForm] = useState(false)
    const [couponCode, setCouponCode] = useState('')
    const [isValidCouponCode, setIsValidCouponCode] = useState(
        initialValues.isValidCouponCode
    )
    const [selectedMembership, setSelectedMembership] = useState(
        initialValues.selectedMembership
    )
    const [newClientInfo, setNewClientInfo] = useState<
        Client | undefined
    >(undefined)
    const [isPaymentSuccessFull, setIsPaymentSuccessful] = useState(false)
    const [displayAvailabilityModal, setDisplayAvailabilityModal] =
        useState(false)
    const stripe = useStripe()
    const [card, setCard] = useState<StripeCardElement>()
    const [err, setErrMsg] = useState('')
    const [isSuccess, setIsSuccess] = useState(false)
    const [availabilityStatus, setAvailablilityStatus] = useState(
        StaffAvailability.AVAILABLE
    )

    async function createPaymentMethod(): Promise<string | void> {
        if (!stripe) {
            // setErrorMessage('no_payment_processor_integration')
            return
        }
        if (!card) return
        const result = await stripe.createPaymentMethod({
            type: 'card',
            card,
        })
        if (result.error) {
            // setErrorMessage(result.error.code || 'card_error')
            return
        }
        return result.paymentMethod.id
    }

    const handleAddAttendeeSubmit = async ({ ...payload }: any) => {
        let res = null
        switch (payload?.type) {
            case 'FREE':
                res = handleFreeBooking({ ...payload })
                break
            case 'PAYMENT':
                res = handlePaymentBooking({ ...payload })
            default:
                null
        }
        return res
    }

    const handleFreeBooking = async ({ ...payload }) => {
        const url = payload.url
        delete payload.url
        delete payload.type
        const booking = await postApiRequest(url, { ...payload })

        return booking
    }

    const handlePaymentBooking = async ({ ...payload }) => {
        let res = null
        const url = payload.url
        delete payload.url
        delete payload.type

        const paymentMethodId = await createPaymentMethod()
        payload.paymentMethodId = paymentMethodId
        if (paymentMethodId) {
            const booking = await postApiRequest(url, { ...payload })
            res = booking
        }

        return res
    }

    const contextValue = {
        formData,
        setFormData,
        attendeeData,
        setAttendeeData,
        displayAddAttendeeModal,
        setDisplayAddAttendeeModal,
        selectedClient,
        setSelectedClient,
        shouldApplyCouponCode,
        setShouldApplyCouponCode,
        applyFreeAppointment,
        setApplyFreeAppointment,
        couponCode,
        setCouponCode,
        isValidCouponCode,
        setIsValidCouponCode,
        displayNewClientForm,
        setDisplayNewClientForm,
        handleAddAttendeeSubmit,
        isPaymentSuccessFull,
        setIsPaymentSuccessful,
        newClientInfo,
        setNewClientInfo,
        selectedMembership,
        setSelectedMembership,
        err,
        setErrMsg,
        isSuccess,
        setIsSuccess,
        availabilityStatus,
        setAvailablilityStatus,
        displayAvailabilityModal,
        setDisplayAvailabilityModal,
        couponInfo,
        setCouponInfo,
    }
    return (
        <AppointmentDrawerProvider value={contextValue}>
            {children}
        </AppointmentDrawerProvider>
    )
}

export default AppointmentDrawerContainer

export const useAppointmentDrawerContext = () =>
    useContext(AppointmentDrawerContext)
